import { render, staticRenderFns } from "./AppCurrencyLabel.vue?vue&type=template&id=9b714070&"
import script from "./AppCurrencyLabel.vue?vue&type=script&lang=js&"
export * from "./AppCurrencyLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports